import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { MessageDialogBaseComponent } from './message-dialog-base/message-dialog-base.component';
import { MessagePromptComponent } from './message-prompt/message-prompt.component';
import { MessagePromptStripeComponent } from './message-prompt-stripe/message-prompt-stripe.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [MessageDialogComponent, MessageDialogBaseComponent, MessagePromptComponent, MessagePromptStripeComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  exports:[MessageDialogComponent]
})

export class MessageDialogModule { }
